import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpand315: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"expand-315, enlarge"} maskId="square-filled-radius-0-stroke-1-IconExpand315"><path fillRule="evenodd" clipRule="evenodd" d="M11 3H3V11H4V4.70711L10.5 11.2071L11.2071 10.5L4.70711 4H11V3ZM12.7929 13.5L19.2929 20H13V21H21V13H20V19.2929L13.5 12.7929L12.7929 13.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExpand315;
